import { Log } from 'ng2-logger';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { Common } from '../../../../core/common';
import Translator from '../../../../core/i18n';
import { IAction, IAppState } from '../../../../models/action/core';
import { IProjectGroupTabProps } from '../../../../models/components/add-activity-project-content';
import * as Actions from '../../../../store/actions/project';
import UserAddModal from './user-add-modal';
import { Confirm } from '../../../../components/notification/main';
import * as coreActions from '../../../../store/actions/core';

const T = Translator.create();
const _logger = Log.create('main-tabpanel');

let _common: Common;

export class CreateGroups extends Component<IProjectGroupTabProps, any> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            addGroupName: '',
            addGroupType: 0,
            groupCount: 0,
            groupSize: 0,
            isEditing: 0,
            isGroupProject: true,
            editingGroupId: '',
            selectedGroupId: '',
            userAddModalIsOpen: false,
            groups: []
        };
    }

    componentDidMount() {
        this.props.dispatch(Actions.getProjectAllGroups(this.props.coursePageClassId!, 1000, 0, '', 'Group', 'addGroupLoading', 'get'));

        this.setState({
            groups: this.props.projectData!.groupList
        });
    }

    componentDidUpdate(prevProps: IProjectGroupTabProps, prevState: any) {
        if (this.props.lastCreatedGroupId !== prevProps.lastCreatedGroupId) {
            this.setState({
                ...this.state,
                addGroupName: '',
                groups: [
                    ...this.state.groups,
                    {
                        hashedGroupId: this.props.lastCreatedGroupId,
                        name: this.state.addGroupName,
                        userCount: 0
                    }
                ]
            });
        }

        if (this.state.groups !== prevState.groups) {
            this.sendGroupsToParent();
        }

        if (this.state.addGroupType !== prevState.addGroupType) {
            this.sendProjectTypeToParent();
        }

        if (this.props.projectData!.groupList !== prevProps.projectData!.groupList) {
            this.setState({
                groups: this.props.projectData!.groupList
            });
        }

        if (this.props.projectData!.isGroupProject !== prevProps.projectData!.isGroupProject) {
            this.setState({
                isGroupProject: this.props.projectData!.isGroupProject
            });
        }
    }

    updateGroupInfo = (_groupId: string, _userCount: number) => {
        const updatedGroups = this.state.groups.map((group: any) =>
            group.hashedGroupId === _groupId ? { hashedGroupId: group.hashedGroupId, name: group.name, userCount: _userCount } : group
        );
        this.setState({
            ...this.state,
            groups: updatedGroups
        });
    };

    addGroupViaEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            this.createGroup();
        }
    };

    createGroup = () => {
        const groupName = this.state.addGroupName.trim();
        groupName && groupName.length >= 3 && !this.state.groups.find((group: any) => group.name === groupName)
            ? this.props.dispatch(
                  Actions.getProjectAddGroup(
                      { classId: this.props.coursePageClassId!, groupId: '', name: this.state.addGroupName, groupType: 1, description: '' },
                      'addGroupLoading',
                      'get'
                  )
              )
            : this.props.dispatch(coreActions.newNotification(T.t('r_enter_valid_group_name'), '', '', 'topRight', 'error'));
    };

    autoCreateGroup = () => {
        this.state.groupCount > 0 && this.state.groupSize > 0
            ? this.props.dispatch(
                  Actions.getProjectAutoAddGroup(
                      { classId: this.props.coursePageClassId!, size: this.state.groupSize, count: this.state.groupCount, groupType: 1 },
                      'addGroupLoading',
                      'get'
                  )
              )
            : this.props.dispatch(coreActions.newNotification(T.t('r_enter_valid_group_size_and_count'), '', '', 'topRight', 'error'));
    };

    updateGroup = () => {
        const groupName = this.state.addGroupName.trim();
        groupName && groupName.length >= 3
            ? this.props.dispatch(
                  Actions.getProjectUpdateGroup(
                      {
                          classId: this.props.coursePageClassId!,
                          groupId: this.state.editingGroupId,
                          name: this.state.addGroupName,
                          groupType: 1,
                          description: ''
                      },
                      'addGroupLoading',
                      'get',
                      this.updateCallback
                  )
              )
            : this.props.dispatch(coreActions.newNotification(T.t('r_enter_valid_group_name'), '', '', 'topRight', 'error'));
    };

    updateCallback = (groupId: string) => {
        const updatedGroups = this.state.groups.map((group: any) =>
            group.hashedGroupId === groupId
                ? { hashedGroupId: group.hashedGroupId, name: this.state.addGroupName, userCount: group.userCount }
                : group
        );
        this.setState({
            ...this.state,
            groups: updatedGroups,
            addGroupName: '',
            editingGroupId: '',
            isEditing: 0
        });
    };

    sendGroupsToParent = () => {
        this.props.sendGroupsToParent!(this.state.groups);
    };

    sendProjectTypeToParent = () => {
        const isGroupProject = this.state.addGroupType === 2 ? false : true;
        this.props.sendProjectTypeToParent!(isGroupProject);
    };

    getUsersOfGroup = (groupId: string) => {
        this.props.dispatch(
            Actions.getProjectFetchUsersOfGroup({
                groupId,
                take: 100,
                skip: 0,
                spinnerId: '',
                spinnerType: 'get'
            })
        );
        this.triggerModal(groupId);
    };

    triggerModal = (groupId: string) => {
        this.setState({
            userAddModalIsOpen: !this.state.userAddModalIsOpen,
            selectedGroupId: groupId
        });
    };

    checkGroupsBeforeSwitch = (addGroupType: number) => {
        if (this.state.groups.length) {
            Confirm.setConfirm(
                'normal',
                () => this.onConfirmSwitchType(addGroupType),
                T.t('r_project_activity_switch_group_add_type_confirm'),
                null
            );
        } else {
            this.setState({ addGroupType });
        }
    };

    onConfirmSwitchType = (addGroupType: number) => {
        const groupIds = this.state.groups.map((group: any) => group.hashedGroupId);

        this.props.dispatch(
            Actions.deleteProjectGroup(groupIds, () => {
                this.setState({ groups: [], addGroupType });
            })
        );
    };

    onDeleteGroup = (groupId: string) => {
        Confirm.setConfirm('normal', () => this.onConfirmDeleteGroup(groupId), T.t('r_delete_project_group_question'), null);
    };

    onEditGroup = (groupId: string) => {
        const editingGroup = this.state.groups.find((group: any) => group.hashedGroupId === groupId);
        this.setState({
            isEditing: 1,
            addGroupName: editingGroup.name,
            editingGroupId: editingGroup.hashedGroupId
        });
    };

    onConfirmDeleteGroup = (groupId: string) => {
        this.props.dispatch(Actions.deleteProjectGroup([groupId], this.deleteGroupFromState.bind(this, groupId)));
    };

    deleteGroupFromState = (groupId: string) => {
        const updatedGroups = this.state.groups.filter((group: any) => group.hashedGroupId !== groupId);

        this.setState({
            groups: updatedGroups
        });
    };

    render() {
        return (
            <React.Fragment>
                <div
                    className={'tab-pane fade' + (this.props.currentTab === '_selectGroupsTab' ? ' show active' : '')}
                    style={{ display: this.props.currentTab === '_selectGroupsTab' ? 'block' : 'none'}}
                    id="select-groups"
                    role="tabpanel"
                    aria-labelledby="select-groups-tab"
                >
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="radio-tabs tick-radio position-relative">
                                        <input
                                            type="radio"
                                            name={'addGroupType'}
                                            // tslint:disable-next-line:jsx-no-lambda
                                            onChange={() => this.checkGroupsBeforeSwitch(0)}
                                            value={0}
                                            checked={this.state.addGroupType === 0}
                                            id="radio-one"
                                            className="form-radio"
                                            defaultChecked={this.state.addGroupType === 0}
                                        />
                                        <label htmlFor="radio-one" style={{marginInlineStart: "6px"}}>{T.t('r_manual')}</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                        <input
                                            type="radio"
                                            name={'addGroupType'}
                                            // tslint:disable-next-line:jsx-no-lambda
                                            onChange={() => this.checkGroupsBeforeSwitch(1)}
                                            value={1}
                                            checked={this.state.addGroupType === 1}
                                            id="radio-two"
                                            className="form-radio"
                                            defaultChecked={this.state.addGroupType === 1}
                                        />
                                        <label htmlFor="radio-two">{T.t('r_auto')}</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                        <input
                                            type="radio"
                                            name={'addGroupType'}
                                            // tslint:disable-next-line:jsx-no-lambda
                                            onChange={() => this.checkGroupsBeforeSwitch(2)}
                                            value={2}
                                            checked={this.state.addGroupType === 2}
                                            id="radio-three"
                                            className="form-radio"
                                            defaultChecked={this.state.addGroupType === 2}
                                        />
                                        <label htmlFor="radio-three">{T.t('r_individual_project')}</label>
                                    </div>
                                </div>
                            </div>
                            <br />
                            {this.state.isEditing ? (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-input form-group">
                                            <input
                                                type="text"
                                                // tslint:disable-next-line:jsx-no-lambda
                                                onChange={event =>
                                                    this.setState({
                                                        addGroupName: event.target.value
                                                    })
                                                }
                                                placeholder={T.t('r_type_the_group_name')}
                                                value={this.state.addGroupName}
                                            />
                                            <span className="highlight" />
                                            <span className="bar" />
                                            <label>Edit</label>
                                        </div>
                                        <button
                                            type="button"
                                            // tslint:disable-next-line:jsx-no-lambda
                                            onClick={() =>
                                                this.setState({
                                                    isEditing: 0,
                                                    addGroupName: ''
                                                })
                                            }
                                            className="category-tag-square tag-gray"
                                        >
                                            <i className="material-icons mr-2">close</i> {T.t('r_gen_cancel')}
                                        </button>
                                        &nbsp;
                                        <button
                                            type="button"
                                            onClick={this.updateGroup}
                                            className="category-tag-square tag-gray pull-right"
                                        >
                                            <i className="material-icons mr-2">add</i> {T.t('r_update')}
                                        </button>
                                    </div>
                                </div>
                            ) : this.state.addGroupType === 0 ? (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-input form-group">
                                            <input
                                                type="text"
                                                // tslint:disable-next-line:jsx-no-lambda
                                                onChange={event =>
                                                    this.setState({
                                                        addGroupName: event.target.value
                                                    })
                                                }
                                                onKeyPress={this.addGroupViaEnter}
                                                placeholder={T.t('r_type_the_group_name')}
                                                value={this.state.addGroupName}
                                                // required={true}
                                            />
                                            <span className="highlight" />
                                            <span className="bar" />
                                            <label>{T.t('r_group_name')}</label>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={this.createGroup}
                                            className="category-tag-square tag-gray pull-right"
                                        >
                                            <i className="material-icons mr-2">add</i> {T.t('r_select_create')}
                                        </button>
                                    </div>
                                </div>
                            ) : this.state.addGroupType === 1 ? (
                                <React.Fragment>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-input form-group">
                                                <input
                                                    type="number"
                                                    // tslint:disable-next-line:jsx-no-lambda
                                                    onChange={event =>
                                                        this.setState({
                                                            groupCount: event.target.value
                                                        })
                                                    }
                                                    placeholder={T.t('r_enter_number_validation')}
                                                    value={this.state.groupCount}
                                                />
                                                <span className="highlight" />
                                                <span className="bar" />
                                                <label>{T.t('r_group_count')}</label>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-input form-group">
                                                <input
                                                    type="number"
                                                    // tslint:disable-next-line:jsx-no-lambda
                                                    onChange={event =>
                                                        this.setState({
                                                            groupSize: event.target.value
                                                        })
                                                    }
                                                    placeholder={T.t('r_enter_number_validation')}
                                                    value={this.state.groupSize}
                                                />
                                                <span className="highlight" />
                                                <span className="bar" />
                                                <label>{T.t('r_group_size')}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={this.autoCreateGroup}
                                        className="category-tag-square tag-gray pull-right"
                                    >
                                        <i className="material-icons mr-2">playlist_add</i>
                                        {T.t('r_gen_add')}
                                    </button>
                                </React.Fragment>
                            ) : this.state.addGroupType === 2 ? (
                                <div className="row">
                                    <div className="col-md-12">
                                        <p className="text-center">{T.t('r_project_activity_personal_group_info_message')}</p>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="row">
                            {this.state.groups && this.state.groups.length
                                ? this.state.groups.map((group: any) => (
                                      <div id={group.hashedGroupId} className="col-md-6" key={group.hashedGroupId}>
                                          <div className="white-boxs" style={{ marginTop: '20px' }}>
                                              <h6>
                                                  {group.name}

                                                  <div className="dropdown pull-right">
                                                      <a data-toggle="dropdown" href="javascript:;" aria-expanded="false">
                                                          <img src={_common.GetDefaultIcons('dots')} alt="Dots" />
                                                      </a>
                                                      <div
                                                          className="dropdown-menu dropdown-menu-right"
                                                          aria-labelledby="dropdownMenuButton"
                                                      >
                                                          <a
                                                              className="dropdown-item"
                                                              // tslint:disable-next-line:jsx-no-lambda
                                                              onClick={() => this.onEditGroup(group.hashedGroupId)}
                                                          >
                                                              {T.t('r_gen_edit')}
                                                          </a>
                                                          <a
                                                              className="dropdown-item"
                                                              // tslint:disable-next-line:jsx-no-lambda
                                                              onClick={() => this.onDeleteGroup(group.hashedGroupId)}
                                                          >
                                                              {T.t('r_gen_delete')}
                                                          </a>
                                                      </div>
                                                  </div>
                                              </h6>
                                              <div className="inner">
                                                  {group.userCount ? (
                                                      <button
                                                          type="button"
                                                          className="category-tag-square tag-gray w-100"
                                                          // tslint:disable-next-line:jsx-no-lambda
                                                          onClick={() => this.getUsersOfGroup(group.hashedGroupId)}
                                                      >
                                                          <i className="material-icons m-r-5">group</i>
                                                          {group.userCount}&nbsp;{T.t('r_participant')}
                                                      </button>
                                                  ) : (
                                                      <button
                                                          type="button"
                                                          className="category-tag-square tag-gray w-100"
                                                          // tslint:disable-next-line:jsx-no-lambda
                                                          onClick={() => this.triggerModal(group.hashedGroupId)}
                                                      >
                                                          <i className="material-icons m-r-5">add</i>
                                                          {T.t('r_add_participants')}
                                                      </button>
                                                  )}
                                              </div>
                                          </div>
                                      </div>
                                  ))
                                : null}
                        </div>
                    </div>
                </div>
                {/* </div> */}
                {this.state.userAddModalIsOpen ? (
                    <UserAddModal
                        isModalOpen={this.state.userAddModalIsOpen}
                        setCloseModal={this.triggerModal}
                        groupId={this.state.selectedGroupId}
                        onUpdateGroup={this.updateGroupInfo}
                        disallowedGroupIds={this.state.groups}
                        selectedGroupId={this.state.selectedGroupId}
                    />
                ) : null}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IProjectGroupTabProps): IProjectGroupTabProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IProjectGroupTabProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        coursePageclassInformation: state.coursePage.coursePageclassInformation,
        projectData: state.project.ProjectData,
        lastCreatedGroupId: state.project.lastCreatedGroupId
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.project.ProjectData.groupList === prev.project.ProjectData.groupList &&
        next.project.lastCreatedGroupId === prev.project.lastCreatedGroupId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const container = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CreateGroups);

export default container;
